<template>
  <div style="background-color: #f5f5f5; overflow: hidden; margin-top: 0.7rem">
    <div class="authentication comBox">
      <div class="authen_head">
        <div class="authen_head_img" @click="imageUrl = loginInfo.avatar ? loginInfo.avatar : '', modifyCover = true">
          <img :src="loginInfo.avatar" alt="" />
        </div>
        <div class="authen_head_right">
          <div>
            <span class="authen_head_right_left">用户名</span>
            <span>
              <span style="display: inline-block; margin-right: 0.16rem">{{
                loginInfo.nickName
              }}</span>
              <!-- <span @click="activeName = '1'" style="color: #165dff">修改</span> -->
            </span>
          </div>
          <div>
            <span class="authen_head_right_left">实名认证</span>
            <span :style="{ color: loginInfo.userrealStatusColor }" class="authen_head_right_renzhenType">
              {{ loginInfo.realStatusName }}
            </span>
          </div>
          <div>
            <span class="authen_head_right_left">账号ID</span>
            <span>{{ loginInfo.code }}</span>
          </div>
          <div>
            <span class="authen_head_right_left">手机号码</span>
            <span>
              <span style="display: inline-block; margin-right: 0.16rem">
                {{
                  loginInfo.phonenumber
                  ? loginInfo.phonenumber.substring(0, 3) +
                  "******" +
                  loginInfo.phonenumber.substring(9, 11)
                  : ""
                }}
              </span>
              <span style="color: #165dff" @click="activeName = '2'">修改</span></span>
          </div>
          <div>
            <span class="authen_head_right_left">注册时间</span>
            <span>{{ loginInfo.createTime }}</span>
          </div>
        </div>
      </div>
      <div class="authen_content">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane label="基本信息" name="1">
            <basicsPage></basicsPage>
          </el-tab-pane>
          <el-tab-pane label="账号安全" name="2">
            <sccountPage></sccountPage>
          </el-tab-pane>
          <el-tab-pane label="账号认证" name="3">
            <enterprisePage :title="router.currentRoute.value.query.type || 0"></enterprisePage>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 上传图片 -->
    <el-dialog title="更换头像" v-model="modifyCover" align-center width="400px" :close-on-click-modal="false">
      <div style="width: 100%">
        <!-- style="width: 800px;" -->
        <el-upload class="avatar-uploader" accept=" image/*" style="border-radius: 50%;" :action="upload_showImage"
          :show-file-list="false" :on-success="onSuccessImages">
          <div style="color: #000;">
            <div class="modifyCoverUpload" v-if="!imageUrl">上传头像</div>
            <!-- <img v-if="!imageUrl" style="width: 100%; height: 1.46rem; object-fit: cover" src="../../assets/LS4.png" /> -->
            <img :src="imageUrl" class="avatar"
              style="object-fit: cover;width:178px;height: 178px;display: block;border-radius: 50%;" />
          </div>

          <!-- <el-icon v-else class="avatar-uploader-icon">
						<div
							style="width:0.3rem;height: 0.3rem;background:url(data:image/png;base64,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) ;background-size: 100%;background-repeat: no-repeat;">
									
						</div>
					</el-icon> -->
        </el-upload>
      </div>

      <div style="margin: 0.12rem 0 0.2rem">
        <div style="
            color: #86909c;
            text-align: center;
            font-size: 0.12rem;
            margin-bottom: 0.02rem;
          ">
          请上传格式为 JPG、JPEG、PNG 的文件。
        </div>
        <div style="color: #86909c; text-align: center; font-size: 0.12rem">
          文件大小不超过 5M。
        </div>
      </div>

      <div class="modifyCoverBnt" @click="submitSaverBg">保存</div>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, FormRules } from "vue";
const imageUrl = ref("");
const modifyCover = ref(false);
import basicsPage from "./basicsPage.vue";
import enterprisePage from "./enterprise/enterprisePage";
import sccountPage from "./sccountPage";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { ElMessage, ElNotification, Message } from "element-plus";
const upload_showImage = ref(serverBaseUrl + "/file/upload");
const router = new useRouter();
document.title = "标识山西-个人中心";
let activeName = ref("1");
if (router.currentRoute.value.query.num) {
  activeName.value = router.currentRoute.value.query.num;
}
let num_type = ref("");
if (router.currentRoute.value.query.params) {
  num_type.value = router.currentRoute.value.query.params;
}
const handleClick = (tab, event) => {
  // console.log(tab, event);
};
const rules = reactive<FormRules>({
  realName: [{ required: true, message: "不能为空！", trigger: "change" }],
  idCard: [{ required: true, message: "不能为空！", trigger: "change" }],
  frontSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
  reverseSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const loginInfo: any = ref({});
const onSuccessImages = (file) => {
  console.log("file", file);
  imageUrl.value = file.data.url;
};
const submitSaverBg = () => {
  // return console.log(imageUrl.value);

  Axios(
    "get",
    `/member/setting-avater`,
    { avater: imageUrl.value },
    false,
    function (res) {
      console.log("=================", res);
      modifyCover.value = false;
      ElMessage.success("上传成功");
      getInfo();
    }
  );
};
const getInfo = () => {
  Axios("get", `/member/login-info`, {}, false, (res) => {
    let data = res.data.data;
    data.realStatusName =
      data.realStatus == 0
        ? "待认证"
        : data.realStatus == 1
          ? "审核中"
          : data.realStatus == 2
            ? "认证成功"
            : "认证失败";
    data.userrealStatusColor == 0
      ? "#ff8c"
      : data.realStatus == 1
        ? "#4169"
        : data.realStatus == 2
          ? "#00cc33"
          : "red";

    loginInfo.value = data;
  });
};
getInfo();
</script>

<style lang="less" scoped>
@import url(/src/assets/css/com.css);

.modifyCoverUpload {
  line-height: 178px;
  font-size: 0.14rem;
  text-align: center;
  color: #000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.authen_head {
  width: 100%;
  background: #fff;
  border-radius: 0.04rem;
  opacity: 1;
  padding: 0.34rem 0.4rem;
  box-sizing: border-box;
  margin: 0.3rem 0 0.16rem;
  display: flex;
  justify-content: flex-start;
}

.authen_content {
  background: #fff;
  padding: 0.2rem 0.4rem 0.7rem;
  box-sizing: border-box;
  border-radius: 0.04rem;
}

.authentication {
  opacity: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 0.3rem;
  box-sizing: border-box;
}

.authen_head_img {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #ccc;
  margin-right: 1rem;
  position: relative;

  img {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
}

.authen_head_img::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 40%;
  height: 40%;
  background-image: url("@/assets/img/tx.png");
  background-size: cover;
  background-position: center;
  border-radius: 50%;
}

.authen_head_right {
  width: calc(100% - 2rem);
  display: flex;
  justify-content: space-between;
  /* flex-direction: column; */
  flex-wrap: wrap;
}

.authen_head_right_renzhenType {
  padding: 0.02rem 0.06remm;
  display: inline-block;
  box-sizing: border-box;
  background: #e8ffea;
  border-radius: 0.02rem 0.02rem 0.02rem 0.02rem;
  color: #00b42a;
}

.authen_head_right>div {
  width: 50%;
}

.authen_head_right_left {
  color: #86909c;
  font-size: 0.14rem;
  margin-right: 0.18rem;
}

/deep/.el-tabs__item.is-active {
  color: #c01a26;
  background: #f2f3f5;
  border-radius: 1rem;
}

/deep/.el-tabs__nav-wrap::after {
  display: none;
}

/deep/.el-tabs__item:hover {
  color: #c01a26;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px !important;
}

/deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
  padding-right: 20px !important;
}

.avatar-uploader {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

/**
	* 上传背景图
	*/
/deep/.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 50%;
  cursor: pointer;
  width: 178px;
  height: 178px;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
  // width: 100%;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

/deep/.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
  background: #f5f5f5;
}

.modifyCoverBnt {
  width: 0.88rem;
  height: 0.37rem;
  margin: 0 auto;
  background: #c01a26;
  color: #fff;
  text-align: center;
  line-height: 0.37rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
}
</style>
